module.exports = __webpack_public_path__ + "static/media/teams.5aeaba14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/teams.jpg
// module id = 855
// module chunks = 9